import axios from 'axios';

export interface notjoinProps {
    loginId: string,
    paramId: string,
    eventUrl: string,
    rotaryCd: string
}

/**
 * イベント参加情報　不参加情報を登録するAPIを呼び出す関数
 */
export async function setNotJoin(props: notjoinProps): Promise<any> {
    try{
        const response = await axios.put(process.env.REACT_APP_PATH + `/users/me/event/unjoin`, null, {
            params: {
                loginId: props.loginId,
                paramId: props.paramId,
                url: props.eventUrl,
                rotaryCd: props.rotaryCd
            },
            paramsSerializer:{
                indexes: null
            }
        });
        return JSON.parse(JSON.stringify(response.data[0]))

    }catch(err){
        console.error(err);
    }
}